import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiError } from 'src/app/models/api/api-error.model';
import { TechService } from 'src/app/services/tech.service';
import { FormControl, FormGroup } from '@angular/forms';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-user-tech-message-dialog',
  template: `<app-dea-dialog-wrapper>
    <div class="fw-semibold fs-4">Nuova comunicazione tech</div>
    <div class="v-spacer"></div>
    <form
      [formGroup]="techMessageForm"
      enctype="multipart/form-data"
      class="m-0 p-0 d-flex flex-column gap-3"
    >
      <app-dea-label [label]="'Deadline:'"></app-dea-label>
      <input
        type="date"
        formControlName="deadline"
        class="form-control dea-form-input mb-3"
        placeholder="Deadline"
      />
      <app-dea-label [label]="'Stripe Link:'"></app-dea-label>
      <input
        type="text"
        formControlName="stripeLink"
        class="form-control dea-form-input mb-3"
        placeholder="Stripe Link"
      />
      <app-dea-label [label]="'Costo (€):'"></app-dea-label>
      <input
        type="text"
        formControlName="price"
        class="form-control dea-form-input mb-3"
        placeholder="Costo"
        justNumber
      />
      <div class="text-danger">{{ error?.message }}</div>
    </form>
    <div class="m-0 p-0 mt-3 gap-2" mat-dialog-actions align="end">
      <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">
        Annulla
      </button>
      <button
        *ngIf="!loading"
        (click)="onConfirm()"
        class="px-5 py-1"
        mat-flat-button
        color="primary"
      >
        Invia
      </button>
      <button *ngIf="loading" class="px-5 py-1" mat-flat-button disabled>
        <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon>
        invia
      </button>
    </div>
  </app-dea-dialog-wrapper>`,
  styles: [],
})
export class UserTechMessageDialogComponent {
  public loading: boolean = false;
  public error?: ApiError;

  public techMessageForm: FormGroup;

  constructor(
    private _dialogRef: MatDialogRef<UserTechMessageDialogComponent>,
    private _techService: TechService,
    @Inject(MAT_DIALOG_DATA)
    public data?: { userId?: string },
  ) {
    this.techMessageForm = new FormGroup({
      user: new FormControl(this.data?.userId),
      deadline: new FormControl(`${new Date().getFullYear()}-09-23`),
      stripeLink: new FormControl(),
      price: new FormControl(150),
    });
  }

  onConfirm(): void {
    this.loading = true;
    this.error = undefined;
    var data = { ...this.techMessageForm.value };
    if (!data.stripeLink) delete data.stripeLink;
    this._techService
      .postUserTechMessage(this.data?.userId, data)
      .subscribe({
        next: (_: any) => this._dialogRef.close(true),
        error: (error: any) => {
          this.error = new ApiError(error);
          console.error('User Post Tech Message Error: ', error);
        },
      })
      .add(() => (this.loading = false));
  }

  onDismiss(): void {
    this._dialogRef.close(false);
  }
}
